import React, { useEffect } from 'react';
import { PlayStoreURL, AppStoreURL, WannaEatBase } from './config/config';
const DeepLinkRedirect = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      // Android → Play Store
      window.location.href = PlayStoreURL;
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      // iOS → App Store
      window.location.href = AppStoreURL;
    } else {
      // Default → Website
      window.location.href = WannaEatBase;
    }
  }, []);

  return (
    <div>
      <h2>Redirecting to app store...</h2>
      <p>If you're not redirected automatically, <a href="https://www.wannaeat.com">click here</a>.</p>
    </div>
  );
};

export default DeepLinkRedirect;
